module.exports = __webpack_public_path__ + "img/ad_6.0ff4e438.png";